import { render, staticRenderFns } from "./gsdet.vue?vue&type=template&id=970836cc&"
import script from "./gsdet.vue?vue&type=script&lang=js&"
export * from "./gsdet.vue?vue&type=script&lang=js&"
import style0 from "./gsdet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports